

export default function About() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Guaranteed',
      description: 'We stand behind our work with a satisfaction guarantee on every service'
    },
    {
      icon: 'ri-time-line',
      title: 'Professional Service',
      description: 'Years of experience delivering exceptional results for our clients'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Eco-Friendly Products',
      description: 'Using premium, environmentally safe detailing products'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Local Experts',
      description: 'Proudly serving Kingston and surrounding areas in Jamaica'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
              Why Choose <span className="text-green-700">Yaad Boyz Detailing</span>
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              At Yaad Boyz Detailing, we're passionate about making your vehicle look its absolute best. Our team of skilled professionals uses premium products and proven techniques to deliver outstanding results every time. Whether you need a quick wash or a complete detailing package, we treat every vehicle with the care and attention it deserves.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We understand that your vehicle is more than just transportation—it's an investment. That's why we go above and beyond to protect and enhance its appearance, ensuring it looks showroom-ready for years to come.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-yellow-400 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-2xl text-green-800`}></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-lg mb-1 text-gray-900">{feature.title}</h3>
                    <p className="text-gray-600 text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/0004be1ba513f59c16e5c0eadce2a018.jpg"
              alt="Professional Auto Detailing"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover"
            />
            <div className="absolute -bottom-6 -left-6 bg-green-700 text-white p-8 rounded-xl shadow-xl">
              <div className="text-5xl font-bold mb-2">5+</div>
              <div className="text-lg">Years of Excellence</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

